// The details of a line joined by middle dots, the empty ones left out:
// « Distri Madinina · Alain Rosier · Fort-de-France ».
const joinDetails = (parts) => parts.filter(Boolean).join(' · ');

export default joinDetails;
